import RestorePasswordPage from './RestorePasswordPage.jsx';

export {
  RestorePasswordPage
};



// WEBPACK FOOTER //
// ./pages/restore-password/index.js